export const ConnectionStatus = {
  SUCCESS: 'success',
  IN_PROGRESS: 'in_progress',
  CREDENTIALS: 'credentials',
  USER_CONFIGURATION: 'user_configuration',
  OTHER: 'other',
};

export const ConnectionStatusMessage = {
  PREFIX: i18n.$t('Most Recent Fetch Status:'),
  SUCCESS: i18n.$t('The last fetch completed successfully'),
  IN_PROGRESS: i18n.$t('in progress'),
  CREDENTIALS: i18n.$t(
    'The last fetch failed due to an authentication error which indicates that the credentials for the given data source are not valid. If the current credentials are still valid, this may also mean that they no longer have access to some of the assignments tied to them. You can refer to the “Assignments with credential errors” section of the Data Load Status dashboard for more details'
  ),
  DEFAULT: i18n.$t(
    'TapClicks was able to connect to the 3rd party data source, but some or all of the data was not retrieved.'
  ),
};

export const ConnectionStatusRoute = {
  CONNECTIONSTATUS: 'connectionstatus',
};

export const ConnectionStatusPathName = {
  CONNECTIONSTATUS: 'connectionstatus',
};

export const ActionIconTypes = {
  DEFAULT: 'default',
  DISABLED: 'disabled',
};

export const DropDownIcon = {
  COG: 'cog',
  PAUSE: 'pause',
  PLAY: 'play-circle',
};
